import React from "react";
import { Stack } from "@mui/material";
import { items } from "./helper";
import { StyledCell } from "./styles";
import { HubIcon, HubTableTemplate } from "../../components";
import { useScannerHelper } from "../../helpers";

const SerializationContentForm = ({
  fields = [],
  append = () => {},
  remove = () => {},
}) => {
  const handleAppend = (label) => {
    const exists = fields?.includes(label);
    if (exists) return;

    append({ label });
  };

  const rows = Array.from(fields)?.map(({ label }, idx) => ({ idx, label }));

  const keys = [
    {
      value: "label",
    },
    {
      value: "remove",
      CustomComponent: ({ item }) => (
        <StyledCell onClick={() => remove(item?.idx)}>
          <HubIcon icon="X" size="10px" />
        </StyledCell>
      ),
    },
  ];

  const headerProps = { items, includeEnd: true };
  const bodyProps = { items: rows, keys };
  const props = { headerProps, bodyProps };

  useScannerHelper(handleAppend, [], true);

  return (
    <Stack gap="15px" width="100%">
      <HubTableTemplate id="LineItemsTable" {...props} />
    </Stack>
  );
};

export default SerializationContentForm;
